import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@renderer/chat/providers'
import { useUser } from '@renderer/chat/store'
import { getPlannerDebugAccess } from './planner-debug-api'

const PLANNER_DEBUG_ACCESS_QUERY_KEY = 'audio-note-planner-debug-access'

export function usePlannerDebugAccess(): boolean {
  const { getAuthToken } = useAuth()
  const user = useUser()
  const userId = user && !user.isAnonymous ? user.id : null
  const access = useQuery({
    queryKey: [PLANNER_DEBUG_ACCESS_QUERY_KEY, userId],
    queryFn: () => getPlannerDebugAccess(getAuthToken),
    enabled: userId !== null,
    staleTime: 1000 * 60 * 5,
  })

  return access.data ?? false
}
